module.exports = "<div class=related__title>{{$ctrl.title}}</div> <div class=related__items> <item class=related__item ng-repeat=\"related in $ctrl.newRelatedList track by $index\" id=related.id name=related.name image=related.image.url ng-click=$ctrl.onClickItem()(related)> </item> </div> <div class=related__more ng-if=$ctrl.showMore ng-click=$ctrl.onClickMore()()> <button class=\"button button--icon-text\"> <span class=icon-plus></span> <span translate=PRODUCT.MORE></span> </button> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/related/related.template.html
// module id = 565
// module chunks = 0